export default __webpack_public_path__ + "static/media/HeaderLogoCleanpro.9f528471.png";